<div class="p-4 px-4 sm:px-8 md:px-16 lg:px-[200px] mx-auto max-w-5xl">
  <div *ngIf="newsItem; else loading">
    <!-- Seu conteúdo atual aqui -->
    <div class="mb-4">
      <a routerLink="/news" class="text-[#669BBC] text-sm hover:underline flex items-center gap-1">
        <i class="bx bx-left-arrow-alt"></i> Voltar para notícias
      </a>
    </div>

    <h5 class="text-2xl font-semibold text-[#C1121F] mb-2">
      {{ newsItem.title }}
    </h5>

    <div class="flex flex-col md:flex-row md:items-center text-sm text-gray-600 mb-4 gap-2">
      <span class="flex items-center">
        <i class="bx bx-calendar text-[#669BBC] mr-1"></i>
        Criado em: {{ newsItem.created_at | date:'dd \'de\' MMMM \'de\' yyyy':'':'pt' }}
      </span>
      <span class="flex items-center">
        <i class="bx bx-refresh text-[#669BBC] mr-1"></i>
        Atualizado em: {{ newsItem.updated_at | date:'dd \'de\' MMMM \'de\' yyyy':'':'pt' }}
      </span>
    </div>

    <img
      [src]="newsItem.image ? 'https://admin.futuroacs.com.br/storage/' + newsItem.image : 'https://api.dicebear.com/9.x/glass/svg?seed=Erick'"
      alt="Imagem da Notícia"
      class="w-full h-auto object-cover mb-6 rounded-md"
    />

    <div *ngIf="safeContent" class="text-base text-gray-800 space-y-4 leading-relaxed" [innerHTML]="safeContent">
    </div>
  </div>

  <ng-template #loading>
    <p>Carregando notícia...</p>
  </ng-template>
</div>